var scope_0 = require('/Users/daunnc/subversions/git/github/pomadchin/my-deck-3/node_modules/mdx-deck/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0e8514935f47d7db6c3cd9049454d72f.js').default;export default
        Object.assign({}, scope_0 )
    